export const EventStatus = {
  SCHEDULED: "SCHEDULED",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
  NO_SHOW: "NO_SHOW",
  IN_PROGRESS: "IN_PROGRESS",
  HOLIDAY: "HOLIDAY",
  RESCHEDULED: "RESCHEDULED",
} as const;

export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus];
